import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg text-foreground-50 whitespace-nowrap">黑料视频</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              黑料视频收录娱乐圈最新最全明星黑料视频，涵盖艺人丑闻、翻车现场、争议事件等真实影像记录，持续更新热门黑料视频内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-200 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/category/mingxing-heiliao" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  明星黑料
                </Link>
              </li>
              <li>
                <Link to="/category/fanche-xianchang" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  翻车现场
                </Link>
              </li>
              <li>
                <Link to="/category/wanghong-heiliao" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  网红黑料
                </Link>
              </li>
              <li>
                <Link to="/category/zhengyi-shijian" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  争议事件
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-200 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/zuixin-baoliao" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  最新爆料
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-200 mb-4">免责声明</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              本站内容来源于网络公开信息整理，仅供娱乐参考。如有任何内容侵犯了您的权益，请通过关于我们页面的联系方式与我们取得联系，我们将及时处理。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 黑料视频 - 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}